export const FIBONACCI_DECK = ['0', '1', '2', '3', '5', '8', '13', '21', '34', '55', '89', '?', '☕'];

export function isValidCard(card: string): boolean {
  return FIBONACCI_DECK.includes(card);
}

export function calculateAverage(votes: string[]): number | null {
  const numeric = votes
    .filter(v => !isNaN(Number(v)))
    .map(Number);

  if (numeric.length === 0) return null;
  return Math.round((numeric.reduce((a, b) => a + b, 0) / numeric.length) * 10) / 10;
}

export function getNearestFibonacci(avg: number): string {
  const numeric = FIBONACCI_DECK.filter(c => !isNaN(Number(c))).map(Number);
  return String(numeric.reduce((prev, curr) =>
    Math.abs(curr - avg) < Math.abs(prev - avg) ? curr : prev
  ));
}
